import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] w-full overflow-hidden bg-black" data-id="element-98">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-99">
        <img src="https://cdn.magicpatterns.com/uploads/2VVDByUigSHLkmsS8mUqwE/Solo_oreja.png" alt="QUID - Filtra el ruido" className="h-full w-full object-cover opacity-70" data-id="element-100" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/80" data-id="element-101" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white sm:px-6 lg:px-8" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl" data-id="element-103">
          <h1 className="mb-6 text-5xl font-extrabold tracking-tight sm:text-6xl md:text-7xl lg:text-8xl" data-id="element-104">
            Bajá el volumen.
            <br data-id="element-105" />
            <span className="text-[#FF6B35]" data-id="element-106">No la experiencia.</span>
          </h1>

          <p className="mx-auto mb-10 max-w-2xl text-xl font-medium text-gray-200 sm:text-2xl" data-id="element-107">
            La música fuerte no es el problema. El problema es no protegerte.
          </p>

          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-108">
            <CTAButton href="#compra" variant="primary" data-id="element-109">
              Conseguir QUID
            </CTAButton>
            <CTAButton href="#problem" variant="secondary" className="!bg-white/10 !text-white backdrop-blur-sm hover:!bg-white/20" data-id="element-110">
              Ver cómo funciona
            </CTAButton>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 1.5
    }} data-id="element-111">
        <div className="h-10 w-6 rounded-full border-2 border-white/30 p-1" data-id="element-112">
          <div className="h-2 w-full rounded-full bg-white/50" data-id="element-113" />
        </div>
      </motion.div>
    </section>;
}